// src/pages/LandingPage.jsx
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import PhotoCarousel from '../components/PhotoCarousel';
import { trackMetric, detectAndStoreTrafficSource } from '../services/telemetryService';

// Catálogo oficial de las 60 imágenes fotográficas verificadas de la edición anterior
const CAROUSEL_IMAGES = [
  '/img/carrousel/xolofest_xolos_interaktia_1.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_2.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_3.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_4.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_5.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_7.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_8.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_10.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_12.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_13.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_14.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_15.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_17.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_18.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_19.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_20.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_21.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_22.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_24.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_25.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_26.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_27.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_28.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_29.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_32.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_34.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_35.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_36.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_37.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_38.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_40.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_41.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_42.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_45.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_46.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_47.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_48.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_50.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_51.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_52.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_53.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_55.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_56.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_57.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_58.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_59.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_60.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_61.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_62.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_63.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_64.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_65.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_66.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_67.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_68.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_69.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_70.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_71.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_73.jpg',
  '/img/carrousel/xolofest_xolos_interaktia_74.jpg'
];

export default function LandingPage() {
  useEffect(() => {
    const source = detectAndStoreTrafficSource();
    if (source === 'b' || source === 'a') {
      trackMetric('qr_scan', { trafficSource: source });
    }
    trackMetric('page_view', { page: 'home', trafficSource: source });
  }, []);

  return (
    <div className="landing-page" style={{ background: 'transparent' }}>
      {/* 1. HERO SECTION CONMEMORATIVO */}
      <section className="hero-section text-center position-relative overflow-hidden" style={{ background: 'transparent' }}>
        <div className="container position-relative z-1 py-3">
          {/* Logo Oficial Xolo Fest */}
          <div className="d-flex justify-content-center mb-4">
            <img
              src="/img/brand/logo-xolofest-vertical.png"
              alt="Xolo Fest 2026 - Club Tijuana Xoloitzcuintles"
              className="hero-shield-img"
              fetchpriority="high"
              loading="eager"
            />
          </div>

          {/* Badge superior */}
          <div className="hero-pill mb-3">
            <i className="bi bi-fire text-danger me-2"></i>
            La gran fiesta oficial de la Jauría Rojinegra
          </div>

          {/* Título Principal */}
          <h1 className="hero-title mb-3">
            ¡NOS VEMOS EN CASA! <br />
            XOLO FEST <span className="hero-title-highlight">2026</span>
          </h1>

          {/* Frase institucional */}
          <p className="hero-subtitle mb-3" style={{ letterSpacing: '0.5px' }}>
            Hay algo que nos une más allá de los 90 minutos: el orgullo de ser Xoloitzcuintle
          </p>

          {/* Descripción */}
          <p className="hero-lead mb-4 mx-auto" style={{ maxWidth: '820px' }}>
            Este 7 de noviembre, el Estadio Caliente se convierte en el punto de encuentro de toda nuestra afición rojinegra. Música en vivo, convivencia y firma de autógrafos con tus Xoloitzcuintles, actividades para toda la familia, regalos y muchas sorpresas. Porque ser Rojinegro se vive dentro y fuera de la cancha. ¡La entrada es libre!
          </p>

          {/* Botones de Acción (3 botones solicitados) */}
          <div className="d-flex flex-wrap justify-content-center gap-3 mb-5">
            <Link to="/r" className="btn btn-xolo-primary btn-lg px-4 py-3 fs-5 shadow-lg d-inline-flex align-items-center gap-2">
              <i className="bi bi-ticket-perforated-fill"></i>
              Registrar mi boleto
            </Link>
            <a href="#experiencias" className="btn btn-xolo-outline btn-lg px-4 py-3 fs-5 d-inline-flex align-items-center gap-2">
              <i className="bi bi-stars"></i>
              Ver Actividades
            </a>
            <a
              href="https://xoloshop.com"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-outline-danger btn-lg px-4 py-3 fs-5 d-inline-flex align-items-center gap-2 text-white bg-black bg-opacity-70 border-danger shadow-lg"
              style={{ borderWidth: '2px' }}
            >
              <i className="bi bi-bag-fill text-danger"></i>
              <span>Anticipar mis compras</span>
            </a>
          </div>

          {/* 4 Stat Cards del Hero (1 por fila en celular, 2 en tablet, 4 en desktop) */}
          <div className="row g-3 justify-content-center text-start hero-stat-cards-row mt-4 mt-lg-5 pt-2">
            {/* Tile 1: Estacionamiento Estadio Caliente */}
            <div className="col-12 col-sm-6 col-lg-3">
              <div className="highlight-stat-card">
                <i className="bi bi-geo-alt-fill text-danger fs-3 mb-2 d-block"></i>
                <div className="stat-title mb-1">Estacionamiento Estadio Caliente</div>
                <div className="stat-desc">Tijuana, Baja California</div>
              </div>
            </div>

            {/* Tile 2: Fecha y hora */}
            <div className="col-12 col-sm-6 col-lg-3">
              <div className="highlight-stat-card">
                <i className="bi bi-calendar-event-fill text-danger fs-3 mb-2 d-block"></i>
                <div className="stat-title mb-1">Fecha y hora</div>
                <div className="stat-desc">Sábado 07 de Noviembre · 12:00 p.m. a 6:00 p.m.</div>
              </div>
            </div>

            {/* Tile 3: 100% Familiar */}
            <div className="col-12 col-sm-6 col-lg-3">
              <div className="highlight-stat-card">
                <i className="bi bi-people-fill text-danger fs-3 mb-2 d-block"></i>
                <div className="stat-title mb-1">100% Familiar</div>
                <div className="stat-desc">Para todas las edades</div>
              </div>
            </div>

            {/* Tile 4: Tómbola Perrona con Imagen Oficial Roja Alineada a la Izquierda */}
            <div className="col-12 col-sm-6 col-lg-3">
              <div className="highlight-stat-card">
                <div className="mb-2 d-flex align-items-center" style={{ height: '36px' }}>
                  <img
                    src="/img/page/tombola-perrona-xolofest-interaktia-rojo.png"
                    alt="Tómbola Perrona"
                    style={{ width: '36px', height: '36px', objectFit: 'contain' }}
                  />
                </div>
                <div className="stat-title mb-1">Tómbola Perrona</div>
                <div className="stat-desc">Premios y promocionales</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 2. SECCIÓN EXPERIENCIAS SIN FILTROS (GRID CONTINUO DE 6 ACTIVIDADES) */}
      <section
        id="experiencias"
        className="py-5 experiences-section"
        style={{
          background: 'transparent',
          borderTop: '1px solid rgba(220, 38, 38, 0.25)',
          borderBottom: '1px solid rgba(220, 38, 38, 0.25)'
        }}
      >
        <div className="container py-4">
          <div className="text-center mb-5">
            <span className="section-pill mb-2">¿Qué Vivirás?</span>
            <h2 className="section-title text-white mt-2">Una Jornada Épica en Casa</h2>
            <p className="section-lead mx-auto">
              Todo el espíritu rojinegro concentrado en un solo lugar con dinámicas diseñadas para ti y tu familia.
            </p>
          </div>

          <div className="row g-4">
            {/* Card 1: Música en vivo */}
            <div className="col-12 col-md-6 col-lg-4">
              <div className="card-experience">
                <div className="card-icon-wrapper">
                  <i className="bi bi-music-note-beamed"></i>
                </div>
                <span className="card-category">Escenario Principal</span>
                <h3 className="card-title">Música en vivo</h3>
                <p className="card-text">
                  Bandas locales y talento local continuo para mantener el ambiente al máximo en el escenario.
                </p>
                <div className="card-footer-badge">
                  <i className="bi bi-clock me-1 text-danger"></i> Durante el evento
                </div>
              </div>
            </div>

            {/* Card 2: Snack Zone */}
            <div className="col-12 col-md-6 col-lg-4">
              <div className="card-experience">
                <div className="card-icon-wrapper">
                  <i className="bi bi-cup-hot-fill"></i>
                </div>
                <span className="card-category">Zona de Alimentos y Bebidas</span>
                <h3 className="card-title">Snack Zone</h3>
                <p className="card-text">
                  La mejor comida y bebida de Tijuana reunida en el Xolo Fest.
                </p>
                <div className="card-footer-badge">
                  <i className="bi bi-shop me-1 text-danger"></i> Mucha variedad
                </div>
              </div>
            </div>

            {/* Card 3: Firma de Autógrafos con tus Xolos */}
            <div className="col-12 col-md-6 col-lg-4">
              <div className="card-experience">
                <div className="card-icon-wrapper">
                  <i className="bi bi-pen-fill"></i>
                </div>
                <span className="card-category">Convivencia Exclusiva</span>
                <h3 className="card-title">Firma de Autógrafos con tus Xolos</h3>
                <p className="card-text">
                  Conoce de cerca a los jugadores y jugadoras del primer equipo varonil y femenil.
                </p>
                <div className="card-footer-badge">
                  <i className="bi bi-pen-fill me-1 text-danger"></i> Firma de autógrafos
                </div>
              </div>
            </div>

            {/* Card 4: Activaciones de marca */}
            <div className="col-12 col-md-6 col-lg-4">
              <div className="card-experience">
                <div className="card-icon-wrapper">
                  <i className="bi bi-gift-fill"></i>
                </div>
                <span className="card-category">Retos & Dinámicas</span>
                <h3 className="card-title">Activaciones de marca</h3>
                <p className="card-text">
                  Todas las marcas patrocinadoras del Club Tijuana Xoloitzcuintles de Caliente reunidas en el evento para ofrecer el mejor entretenimiento para ti.
                </p>
                <div className="card-footer-badge">
                  <i className="bi bi-gift-fill me-1 text-danger"></i> Gana Souvenirs de las marcas
                </div>
              </div>
            </div>

            {/* Card 5: Zona Xolokids */}
            <div className="col-12 col-md-6 col-lg-4">
              <div className="card-experience">
                <div className="card-icon-wrapper">
                  <i className="bi bi-emoji-smile-fill"></i>
                </div>
                <span className="card-category">Para los Pequeños</span>
                <h3 className="card-title">Zona Xolokids</h3>
                <p className="card-text">
                  Minipitch (canchita de futbol), juegos de feria y más.
                </p>
                <div className="card-footer-badge">
                  <i className="bi bi-shield-check me-1 text-danger"></i> Área segura
                </div>
              </div>
            </div>

            {/* Card 6: Tienda Oficial XoloShop con Logo WebP */}
            <div className="col-12 col-md-6 col-lg-4">
              <div className="card-experience d-flex flex-column justify-content-between">
                <div>
                  <div className="d-flex align-items-center justify-content-between mb-2">
                    <span className="card-category mb-0">Tienda Oficial</span>
                    <i className="bi bi-bag-check-fill text-danger fs-4"></i>
                  </div>
                  <div className="my-2 py-1">
                    <img
                      src="/img/page/xoloshop-logo.webp"
                      alt="Logo Oficial XoloShop"
                      style={{ maxHeight: '42px', maxWidth: '160px', objectFit: 'contain' }}
                    />
                  </div>
                  <p className="card-text">
                    Adquiere jersey oficiales, souvenirs y productos oficiales para tus firmas con los jugadores.
                  </p>
                </div>
                <div className="mt-3">
                  <a
                    href="https://xoloshop.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-xolo-primary btn-sm d-inline-flex align-items-center justify-content-center gap-2 fw-bold text-center w-100 py-2"
                  >
                    <span>Anticipa tus compras en el punto de venta físico o en nuestra tienda digital</span>
                    <i className="bi bi-box-arrow-up-right"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 3. SECCIÓN: CARRUSEL DE FOTOS EDICIÓN ANTERIOR */}
      <section id="galeria" className="py-5 carousel-section" style={{ background: 'transparent' }}>
        <div className="container py-4 text-center">
          <span className="section-pill mb-2">Galería Fotográfica</span>
          <h2 className="section-title text-white mt-2">Revive la Pasión: Edición Anterior</h2>
          <p className="section-lead mx-auto mb-5">
            Un vistazo a los grandes momentos, la emoción y la fiesta que vivió la Jauría Rojinegra en nuestra edición pasada.
          </p>

          <PhotoCarousel images={CAROUSEL_IMAGES} />
        </div>
      </section>

      {/* 4. SECCIÓN TÓMBOLA PERRONA INFORMATIVA (SIN LOS 3 BULLETS ESPECÍFICOS) */}
      <section
        id="tombola"
        className="py-5 tombola-section"
        style={{
          background: 'transparent',
          borderTop: '1px solid rgba(220, 38, 38, 0.25)'
        }}
      >
        <div className="container py-4">
          <div className="row align-items-center g-5">
            <div className="col-12 col-lg-7 text-center text-lg-start">
              <span className="section-pill mb-2">GANA PREMIOS Y PROMOCIONALES</span>
              <h2 className="section-title text-white mt-2 d-inline-flex align-items-center gap-2">
                <span>La Tómbola Perrona</span>
                <img
                  src="/img/page/tombola-perrona-xolofest-interaktia.png"
                  alt="Tómbola Perrona"
                  style={{ width: '36px', height: '36px', objectFit: 'contain', verticalAlign: 'middle' }}
                />
              </h2>
              <p className="text-white fs-5 mt-3 mb-4 mx-auto mx-lg-0" style={{ textShadow: '0 2px 10px rgba(0,0,0,0.95)', maxWidth: '640px' }}>
                Todos los asistentes con boleto registrado participan en la tómbola perrona, asegura que tu folio participa para ganar premios y promocionales increíbles en el escenario principal.
              </p>

              <div className="d-flex justify-content-center justify-content-lg-start">
                <Link to="/r" className="btn btn-xolo-primary btn-lg px-4 py-3 fw-bold fs-6">
                  <i className="bi bi-ticket-perforated-fill me-2"></i>
                  Registrar mi boleto
                </Link>
              </div>
            </div>

            {/* Callout lateral de registro */}
            <div className="col-12 col-lg-5 text-center">
              <div className="p-4 p-md-5 rounded-4 bg-black border border-danger border-opacity-50 shadow-lg text-light">
                <i className="bi bi-qr-code-scan display-3 text-danger mb-3 d-block"></i>
                <h3 className="h4 fw-bold text-white mb-2">¿Tienes tu boleto en mano?</h3>
                <p className="text-light opacity-90 small mb-4">
                  ¡Regístrate! Es sencillo y te tomará menos de 15 segundos
                </p>
                <Link to="/r" className="btn btn-xolo-primary w-100 py-3 fw-bold fs-6">
                  <i className="bi bi-ticket-perforated-fill me-2"></i>
                  Registrar mi boleto
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
